import React from 'react'
import StatsAndStandingsHomeNavigation from './StatsAndStandingsHomeNavigation'

const StatsAndStandingsHome = () => {
	return (
		<div>
			<StatsAndStandingsHomeNavigation />
		</div>
	)
}

export default StatsAndStandingsHome
